var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-comments","titulo":"CONTRATAÇÕES SEM AVALIAÇÃO","qtd":_vm.qtd,"loading":_vm.loading,"color":"#A3E0FC"}})
}
var staticRenderFns = []

export { render, staticRenderFns }